module.exports = __webpack_public_path__ + "img/detroit-lions.726e0725.svg";